export const baseUrl = "https://api.novarace.in/api/";
//export const baseUrl = "http://localhost:3001/api/";
